import { render, staticRenderFns } from "./UsefulContentListMenu.vue?vue&type=template&id=5d95a6fd&scoped=true&"
import script from "./UsefulContentListMenu.vue?vue&type=script&lang=js&"
export * from "./UsefulContentListMenu.vue?vue&type=script&lang=js&"
import style0 from "./UsefulContentListMenu.vue?vue&type=style&index=0&id=5d95a6fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95a6fd",
  null
  
)

export default component.exports